import {
    whiteColor,
    boxShadow,
} from '../global';

const loginAdminStyle = (theme) => ({
    wrapper: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    BoxContent: {
        [theme.breakpoints.up('md')]: {
            margin: 'auto',
            width: '70%',
            display: 'flex',
            justifyContent: 'center',
        },
    },
    mainBox: {
        [theme.breakpoints.up('md')]: {
            margin: 'auto',
            width: '70%',
            display: 'flex',
            justifyContent: 'center',
        },
    },
    input: {
        margin: 0,
    },
    item: {
        margin: '10px 0 0 0',
    },
    itemSub: {
        margin: '0 0 10px 0',
    },
    background: {
        minHeight: '700px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: whiteColor,
        display: 'flex',
        borderRadius: '8px',
        // [theme.breakpoints.up('md')]: {
        //     backgroundImage: 'url("/resources/mask_group.png")',
        //     backgroundPosition: 'left',
        //     backgroundSize: 'auto',
        //     backgroundRepeat: 'no-repeat',
        // },
        ...boxShadow,
    },
});

export default loginAdminStyle;
